import { Box, Flex } from '@chakra-ui/react';
import { Navigate, Outlet } from 'react-router-dom';

import { routes } from '@blockpulse3/data/shared';
import { UserRole } from '@blockpulse3/graphql/hooks';
import { useUser } from '@blockpulse3/web-client/auth';
import { Sidebar } from '@blockpulse3/web-client/sidebar';

type Props = unknown;

export function AdminLayout(): JSX.Element {
  const { user } = useUser();

  // proctect /manage path, if user not SUPERADMIN redirect to /me
  if (user && !user.roles.includes(UserRole.SUPERADMIN)) {
    return <Navigate replace to={routes.me.href} />;
  }

  return (
    <Flex as="section" direction={{ base: 'column', lg: 'row' }} height="auto" minH="100vh">
      <Sidebar bg="black" />
      <Box w="64" />
      <Box bg="gray.100" flex="1" overflowY="auto" px={{ base: '4', md: '8' }} py="6">
        <Outlet />
      </Box>
    </Flex>
  );
}

export type AdminLayoutProps = Props;
